var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"closure-object"},[(_vm.source)?_c('attributes-list',{attrs:{"model":_vm.model,"source":_vm.source,"related":_vm.related,"is-editing":""},on:{"hasChanges":function($event){return _vm.$emit('hasChanges')}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }